import { SlotHolidayProvider, useSlotHolidayFlow } from "./SlotHolidayProvider";
import SelectDatesScreen from "./SelectDatesScreen";
import LoadingScreen from "./LoadingScreen";
import ConfirmationScreen from "./ConfirmationScreen";
import type { Booking } from "@/types/Booking";

type SlotHolidayContainerProps = {
  onClose?: () => void;
  booking?: Booking;
};

const SlotHolidayContainer = ({ onClose, booking }: SlotHolidayContainerProps) => {
  return (
    <SlotHolidayProvider booking={booking}>
      <SlotHolidayFlowContent onClose={onClose} />
    </SlotHolidayProvider>
  );
};

const SlotHolidayFlowContent = ({ onClose }: SlotHolidayContainerProps) => {
  const { step, isLoading } = useSlotHolidayFlow();

  let currentScreen: React.ReactNode = null;

  // Step 1: Select dates for slot holiday
  if (step === 1) {
    currentScreen = <SelectDatesScreen onClose={onClose} />;
  }
  // Step 2: Loading - applying slot holiday
  else if (step === 2 && isLoading) {
    currentScreen = <LoadingScreen />;
  }
  // Step 3: Confirmation
  else if (step === 3) {
    currentScreen = <ConfirmationScreen onClose={onClose} />;
  }
  // Fallback
  else {
    currentScreen = <div>Unknown State</div>;
  }

  return (
    <div className="w-full mx-auto" data-testid="slot-holiday-flow-container">
      {currentScreen}
    </div>
  );
};

export default SlotHolidayContainer;
